import { applyTicketFilters, ticketFilterParams } from "../listFilters";
import { connect } from "react-redux";
import React from "react";
import "antd/dist/antd.css";
// import "./index.css";
import { Button, Col, Row, Table, Radio, Tooltip, Input } from "antd";
import { withRouter } from "react-router-dom";
import { authAxios } from "../utils";
import {
  listHandlingLoaiyeucau,
  ListStatusURL,
  ticketsPersonalListURL,
  url_get_list_team,
} from "../constants";
import moment from "moment";
import { AdvancedSearchForm } from "./Component";
import Cookies from "universal-cookie";
import FilterOutlined from "@ant-design/icons/lib/icons/FilterOutlined";
import { QuestionCircleOutlined } from "@ant-design/icons";
const cookies = new Cookies();

const getColumns = (data_state) => [
  // {
  //     title: "STT",
  //     dataIndex: "index",
  //     key: "index",
  //     render: (value, item, index) => ((pagination.current || 1) - 1) * pagination.pageSize + index + 1,
  //     sorter: (a, b) => a.index - b.index,
  //     sortDirections: ['descend', 'ascend', 'descend'],
  // },

  {
    title: "Mã yêu cầu",
    dataIndex: "ticket_code",
    key: "ticket_code",
    sorter: (a) => a,
    render: (value, item, index) => <a href={"/tickets/" + item.id}>{value}</a>,
    filterKey: "ticket_code",
    type: "text",
    canSearch: true,
    fixed: "left",
    // width: 150,
    width: "7%",
  },
  {
    title: "Loại yêu cầu",
    dataIndex: "ticket_type_name",
    key: "ticket_type_name",
    sorter: (a) => a,
    filterKey: "ticket_type_name",
    width: "11%",
    type: "option",
    canSearch: true,
    lsOption: data_state.lsOption,
  },
  {
    title: "Tiêu đề",
    dataIndex: "title",
    key: "title",
    ellipsis: true,
    filterKey: "title",
    width: "20%",
    type: "text",
    canSearch: true,
    // sortDirections: ['ascend', 'descend', 'ascend'],
    // sorter: (a, b) => a.title - b.title,
  },
  {
    title: (
      <>
        Phòng/Department
        <Tooltip title="Phòng/Department">
          <QuestionCircleOutlined style={{ marginLeft: 5 }} />
        </Tooltip>
      </>
    ),
    dataIndex: "bophansudung_name",
    key: "bophansudung_name",
    filterKey: "bophansudung_name",
    width: "5%",
    type: "text",
    canSearch: true,
    searchTitle: "Phòng/Department",
  },
  {
    title: (
      <>
        Team
        <Tooltip title="Team sử dụng">
          <QuestionCircleOutlined style={{ marginLeft: 5 }} />
        </Tooltip>
      </>
    ),
    dataIndex: "list_name_team_use",
    key: "list_name_team_use",
    filterKey: "team_id",
    width: "5%",
    type: "option",
    mode: "multiple",
    lsOption: data_state.lsTeam,
    canSearch: true,
    searchTitle: "Team",
    render: (text, record) =>
      record.list_name_team_use &&
      record.list_name_team_use.map((item) => item.name).join(", "),
  },
  {
    title: "Văn phòng",
    dataIndex: "vanphong_name",
    key: "vanphong_name",
    filterKey: "vanphong_name",
    width: "6%",
    // filters: [
    //   { text: "DSP", value: "DSP" },
    //   { text: "Seatech", value: "Seatech" }
    // ],
    // filteredValue: filteredInfo.vanphong || null,
    // onFilter: (value, record) => record.vanphong.includes(value),
    sorter: (a) => a,
    type: "text",
    canSearch: true,
    // sortOrder: sortedInfo.columnKey === "vanphong" && sortedInfo.order
  },
  {
    title: "Ngày mong muốn",
    dataIndex: "duedate",
    key: "duedate",
    filterKey: "duedate",
    width: "7%",
    render: (text, record) => moment(text).format("L"),
    sorter: (a) => a,
    type: "date",
    canSearch: true,
  },
  {
    title: "Người phê duyệt",
    dataIndex: "approve_user_name",
    key: "approve_user_name",
    filterKey: "approve_user_name",
    width: "7%",
    sorter: (a) => a,
    type: "text",
    canSearch: true,
  },
  {
    title: "Trạng thái",
    dataIndex: "ticket_status_name",
    key: "ticket_status_name",
    filterKey: "ticket_status_name",
    width: "7%",
    type: "option",
    lsOption: data_state.lsStatus,
    canSearch: true,
    sorter: (a) => a,
    render: (text, record) => (
      <a
        style={{
          backgroundColor: record.color,
          color: "#ffffff",
          padding: "3px 5px 3px 5px",
        }}
      >
        {text}
      </a>
    ),
  },
  {
    title: "Cập nhật bởi",
    dataIndex: "updating_user_name",
    key: "updating_user_name",
    filterKey: "updating_user_name",
    width: "7%",
    type: "text",
    canSearch: true,
  },
  {
    title: "Ngày tạo",
    dataIndex: "created",
    key: "created",
    filterKey: "created",
    width: "7%",
    render: (text, record) => moment(text).format("L"),
    sorter: (a) => a,
    type: "date_range",
    canSearch: true,
  },
];

const suffixSearch = (
  <Tooltip title="Tìm theo Mã Ticket, Tiêu đề, Ghi chú, Phòng/Department, Team sử dụng, Ngày tạo (DD/MM/YYYY)">
    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
  </Tooltip>
);
class Danhsachyeucau extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    data: [],
    total_page: "",
    pagination: { pageSize: 10, current: 1, page: 1 },
    lsStatus: [],
    searching: false,
    paramsSearch: { searchAll: "" },
    lsOption: [],
    screenWidth: window.innerWidth,
    changeSearchAllValue: "",
    lsTeam: [],
  };
  componentDidMount() {
    this.setState({ loading: true });
    this.fetchStatusListAPI();
    this.fetchTicketListAPI({
      page_size: this.state.pagination.pageSize,
      page: 1,
      columnSort: "id",
      typeSort: "descend",
    });
    this.fetchListLoaiYeuCau();
    this.fetchTeamListAPI();
  }

  handleChange = (pagination, filters, sorter, extra) => {
    this.setState({ loading: true });
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    pager.pageSize = pagination.pageSize;
    this.setState({
      pagination: pager,
      sortedInfo: sorter,
    });
    this.fetchTicketListAPI({
      page_size: pagination.pageSize,
      page: pagination.current,
      columnSort: sorter.field || "id",
      typeSort: sorter.order || "descend",
      ...filters,
      ...this.state.paramsSearch,
    });
  };

  fetchStatusListAPI = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(ListStatusURL)
      .then((res) => {
        let lsTemp = [{ label: "Tất cả", value: "-1" }];
        res.data.results
          .filter((item) => item.id !== 1)
          .map((item, index) => {
            lsTemp.push({ label: `${item.name}`, value: `${item.id}` });
          });

        this.setState({ lsStatus: lsTemp });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        // if (err.response.status === 401) {
        //     this.props.history.push('/login');
        // }
      });
  };

  fetchListLoaiYeuCau = () => {
    authAxios(cookies.get("token"))
      .get(listHandlingLoaiyeucau)
      .then((res) => {
        let lsTemp = [{ label: "Tất cả", value: undefined }];
        res.data.map((item, index) => {
          lsTemp.push({
            label: `${item.handling_group_name + "-" + item.name}`,
            value: `${item.name}`,
          });
        });
        this.setState({ lsOption: lsTemp });
      });
  };
  fetchTeamListAPI = () => {
    authAxios(cookies.get("token"))
      .get(url_get_list_team)
      .then((res) => {
        let lsTemp = [];
        res.data.map((item) => {
          lsTemp.push({
            label: item.name,
            value: item.id,
          });
        });
        this.setState({ lsTeam: lsTemp });
      })
      .catch((err) => {
        console.error("Lỗi fetch team: ", err);
      });
  };
  fetchTicketListAPI = (params = {}) => {
    params = ticketFilterParams(params, true);
    const requestId = this.ticketRequestId = (this.ticketRequestId || 0) + 1;
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(ticketsPersonalListURL, { params: params })
      .then((res) => {
        if (requestId !== this.ticketRequestId) return;
        this.setState({
          data: res.data.results,
          loading: false,
          total_page: res.data.count,
        });
      })
      .catch((err) => {
        if (requestId !== this.ticketRequestId) return;
        this.setState({ error: err, loading: false });
        if (err.response?.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  filterTicketList = (params = {}) => {
    applyTicketFilters(this, params);
  };

  // SearchTicketList = (value, event) => {
  //     let {sortKey, sortDirection, pageSize} = this.state;
  //     const pager = {...this.state.pagination};
  //     pager.current = 1;
  //     pager.page = 1;
  //     this.setState({searchKey:value,pagination:pager})
  //     this.fetchTicketListAPI({
  //         page_size: this.state.pagination.pageSize,
  //         page: 1,
  //         columnSort: 'id',
  //         typeSort: 'descend',
  //         search: value,
  //     })
  // }
  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };
  callBackFilter = (values) => {
    this.filterTicketList(values);
  };

  onChangeSearchAll = (value) => {
    this.setState({ changeSearchAllValue: value });
    if (
      value.trim() === "" &&
      (this.state.paramsSearch.searchAll || "").trim() !== ""
    ) {
      this.onSearchAll("", true);
    }
  };

  onSearchAll = (values) => {
    this.setState({ changeSearchAllValue: values });
    this.filterTicketList({ searchAll: values });
  };

  render() {
    let {
      loading,
      data,
      total_page,
      pagination,
      screenWidth,
      changeSearchAllValue,
    } = this.state;
    let { userPermission } = this.props;
    const columns = getColumns(this.state);

    const toggleSearchForm = () => {
      const searching = this.state.searching;
      this.setState({ searching: !searching });
    };
    const onFilterButton = (e) => {
      let obj = {};
      if (e.target.value !== "all") {
        obj.typeView = e.target.value;
      } else {
        obj.typeView = undefined;
      }
      this.filterTicketList(obj);
    };
    return (
      <>
        <Row justify="end">
          <Col sm={screenWidth > 1680 ? 6 : screenWidth > 1254 ? 7 : 8}>
            <Input.Search
              value={changeSearchAllValue}
              placeholder="Tìm kiếm nhanh"
              onChange={(e) => this.onChangeSearchAll(e.target.value)}
              onSearch={this.onSearchAll}
              enterButton
              allowClear
              suffix={suffixSearch}
              className="search-all-list-ticket"
            />
          </Col>

          <Col
            sm={screenWidth > 1680 ? 1.5 : 2}
            style={{ paddingLeft: "10px" }}
          >
            <Button
              onClick={toggleSearchForm}
              style={{ width: "100%" }}
              icon={<FilterOutlined />}
            >
              Lọc
            </Button>
          </Col>
        </Row>

        <Row>
          <Col sm={16} style={{ float: "left", marginBottom: 15 }}>
            <Radio.Group
              options={[
                { label: "TẤT CẢ", value: "all" },
                { label: "ĐANG XỬ LÝ", value: "processing" },
                { label: "CẦN XỬ LÝ", value: "handle" },
                { label: "ĐÃ DUYỆT", value: "accepted" },
                { label: "ĐÃ TIẾP NHẬN", value: "received" },
              ]}
              onChange={onFilterButton}
              defaultValue={"all"}
              optionType="button"
              buttonStyle="solid"
            />
          </Col>
          {this.state.searching ? (
            <AdvancedSearchForm
              Columns={columns}
              lsStatus={this.state.lsStatus}
              paramsSearch={this.state.paramsSearch}
              callBackFilter={this.callBackFilter}
            />
          ) : null}
        </Row>

        <Table
          dataSource={data}
          columns={columns}
          loading={loading}
          bordered={true}
          scroll={{ x: 1200 }}
          rowClassName={(record) =>
            moment(record.duedate) <= moment(new Date()) &&
            ![4, 5, 7].includes(record.ticket_status)
              ? "expired"
              : "data-row"
          }
          rowKey="id"
          className="styleTable_1"
          size="small"
          onRow={(record) => ({
            onDoubleClick: () => {
              this.props.history.push(`/tickets/${record.id}`);
            },
          })}
          onChange={this.handleChange}
          pagination={{
            current: this.state.pagination.current,
            pageSize: this.state.pagination.pageSize,
            total: total_page,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["10", "15", "25", "50"],
          }}
        />
      </>
    );
  }
}

// ReactDOM.render(<App />, document.getElementById("container"));

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.token !== null,
    userPermission: state.user.userPermission,
  };
};
// export default connect(mapStateToProps)(withRouter(Danhsachyeucau));

export default withRouter(connect(mapStateToProps)(Danhsachyeucau));
